import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EntityForm from "./components/EntityForm";

import {
  useDetailEntityQuery,
  useEditEntityMutation,
} from "store/services/entityApi";

const EntityEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Entity Detail", path: `/app/crm/entity/${id}/detail` },
    { title: "Edit Entity" },
  ];

  //   RTK Query
  const {
    data: entityDetail,
    isLoading: loadingEntityDetail,
    error,
  } = useDetailEntityQuery(id);

  const [updateEntity, { isLoading: updatingEntity }] = useEditEntityMutation();

  //   methods
  const handleUpdateEntity = async (data) => {
    try {
      await updateEntity({
        ...data,
        id,
      }).unwrap();
      toast.success("Entity Detail successfully updated!");
      navigate(`/app/crm/entity/${id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update entity!");
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingEntityDetail || updatingEntity}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <EntityForm
          isBusy={loadingEntityDetail || updatingEntity}
          entityDetail={entityDetail}
          onSubmit={handleUpdateEntity}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default EntityEditScreen;
